function ErrorsAggregator(componentName) {
  this.name = 'ErrorsAggregator';
  this.componentName = componentName;
  this.errors = [];
  this.updateMessage();
}

ErrorsAggregator.prototype = Object.create(Error.prototype);
ErrorsAggregator.prototype.constructor = ErrorsAggregator;
ErrorsAggregator.prototype.updateMessage = function() {
  var message = null;
  if (this.errors.length === 0) {
    message = 'no errors';
  } else {
    message = this.errors
      .map(function(error) {
        return error.toString();
      })
      .join('\n');
  }

  this.message = "Aggregated errors for '" + this.componentName + "': " + message;
};
ErrorsAggregator.prototype.hasErrors = function() {
  return this.errors.length > 0;
};
ErrorsAggregator.prototype.addError = function(error) {
  this.errors.push(error);
  this.updateMessage();
};

export default ErrorsAggregator;
